<template>
    <div class="resetpassword">
        <h1>
            Reset Your Password!
        </h1>
        <!--<alert v-if="changePwdSuccess" placement="top-right" duration="3000" type="success" width="400px" dismissable>-->
            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
            <!--<strong>Sent!</strong>-->
            <!--<p id="resetpwd_successmsg">Password Changed Successfully. Redirecting to Tone Networks..</p>-->
        <!--</alert>-->
        <div class="form">
            <form v-on:submit.prevent="onSubmit">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center" >
                    <vue-password v-model="forgetpassword.newPassword"
                                  :minlength="6"
                                  classes="input"
                                  class="form-input"
                                  placeholder="Password"
                                  error="Password"
                                  id = "resetpassword_password"
                                  :disableStrength = "hidePasswordMeter"
                                  required
                                  icon
                    >
                    </vue-password>
                    <span  class="icon-info-circled alert-icon-float-left information">
                                                        <p class="alert alert-info alert-dismissable"  id="resetpassword_pwderrormsg"
                                                           :class = "{'set-error': !verifyPassword()}">Min 6 Chars, One Upper Case, One Lower Case!</p>
                                                        </span>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                    <button class="btn formButton btn-block" id="resetpassword_reset">
                        Reset Password
                    </button>
                    <!--<button type ="button" class="btn formButton btn-block" id="resetpassword_cancel" v-on:click="redirectLogin">-->
                        <!--Cancel-->
                    <!--</button>-->
                </div>
            </form>
            <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                <span class="icon-info-circled alert-icon-float-left"></span>
                <strong>Error:</strong>
                <p id="resetpassword_errormsg">{{error.message}}</p>
            </alert>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { input, alert, spinner } from 'vue-strap'
import VuePassword from 'vue-password'
var crypto = require('crypto')
export default {
    components: {
        'bs-input': input, 'alert': alert, 'spinner': spinner, VuePassword
    },
    name: 'resetpassword',
    data: function () {
        return {
            forgetpassword: {
                email: '',
                forgotPasswordCode: '',
                newPassword: ''
            },
            confirmPassword: '',
            passwordError: '',
            spinner: false,
            alert: false,
            changePwdSuccess: false,
            hidePasswordMeter: true
        }
    },
    methods: {
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        redirectLogin: function (event) {
            this.$router.push('/')
        },
        onSubmit: function () {
            let self = this
            if (this.forgetpassword && this.verifyPassword()) {
                this.$store.dispatch('CONFIRMPASSWORD', {user: this.forgetpassword}).then(() => {
                    if (!self.error.show) {
                        self.$swal({
                            title: 'Password Reset!',
                            text: 'Password Changed Successfully. Redirecting to Tone Networks..',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        self.$router.push('/')
                    } else {
                        this.$swal({
                            title: 'Password Reset Failed!',
                            text: 'Password request expires after 24 hours. Please generate a new password request and follow the link',
                            type: 'error',
                            timer: 6000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        this.$router.push('/')
                    }
                })
            }
        },
        verifyPassword: function () {
            if (this.forgetpassword.newPassword.length >= 6) {
                let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
                if (!re.test(this.forgetpassword.newPassword)) {
                    return false
                } else {
                    return true
                }
            } else {
                if (this.forgetpassword.newPassword.length > 0) {
                    return false
                } else {
                    return true
                }
            }
//            if (this.forgetpassword.newPassword.length >= 6) {
//                let re = /^(?=.*?[A-Z])(?=.*?[a-z]).{6,}$/
//                if (!re.test(this.forgetpassword.newPassword)) {
//                    this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
//                    return false
//                } else {
//                    return true
//                }
//            } else {
//                return false
//            }
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'isUserLoggedIn'
        ])
    },
    mounted: function () {
        // Validate if coming from Link
       // console.log('called', this.$route.query.params)
        if (this.$route.query.params && !this.isUserLoggedIn) {
            // slice the params
            let encryptedEmail = this.$route.query.params.substr(0, this.$route.query.params.indexOf('^'))
            let validationCode = this.$route.query.params.substr(this.$route.query.params.indexOf('^') + 1)
            // Decrypt the email
            let decipher = crypto.createDecipher('aes-256-cbc', 'tonenetworks')
            let decrypted = decipher.update(encryptedEmail, 'hex', 'utf-8')
            decrypted = decrypted + decipher.final('utf-8')
            this.forgetpassword.email = decrypted
            this.forgetpassword.forgotPasswordCode = validationCode
        } else {
            this.$router.push('/')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .set-error{
        border-color: #a94442 !important;
        color:#a94442 !important;
    }
    .form{
        text-align: left;
        width: 40%;
        margin: 50px auto;
        overflow: hidden;
    }
    .h1{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .padding-minus{
        padding:0;
    }
    .form .form-input{
        margin-bottom: 25px ;
    }
    .form .forgotPassword{
        float: right;
        color: black
    }
    .form .forgotPassword:hover{
        float: right;
        color: #337ab7;
    }
    @media (max-width:767px){
        .form {
            width: 100%;
        }
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: #91ab45;
        border-color: #91ab45;
        background-color: transparent;
        transition: 0.5s;
        padding:0;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
        color: #ffffff;
    }
    .btn-spinner{
        bottom:15px
    }
    h1 {
        color: #f0617d;
        margin: 70px 0 30px;
    }

</style>
<style>
    input.form-control , #resetpassword_password {
        height: 57px;
        border-radius: 0;
        padding:10px;
    }
    span.form-control-feedback {
        height: 47px;
        line-height: 47px;
    }

    svg.VuePassword__Meter {
        margin: 20px 0 0;
    }
    .formButton.btn.btn-block{
        outline: none;
        border-radius: 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        padding: 1em 1em;
        background: #f0617d;
        border: 1px solid #f0617d;
        color: #fff;
        width: 100%;
        margin: 20px 0 ;
        height: auto;
    }

    button#resetpassword_cancel {
        background:#ddd;
        border-color:#ddd;
    }

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?0ac7942e